import { LoadablePaint } from '@confluence/loadable';

export const PageTreeSSRExtensionHandler = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageTreeSSRExtensionHandler" */ '../src/PageTreeSSRExtensionHandler.tsx'
			)
		).PageTreeSSRExtensionHandler,
});
